module.exports = __webpack_public_path__ + "static/media/fries-emoji.d62612a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fries-emoji.png
// module id = 36
// module chunks = 0